import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  @Input() open = false;
  @Input() title = 'Confirm action';
  @Input() message = 'Are you sure?';
  /** HTML-formatted message shown when provided; takes precedence over plain `message`. */
  @Input() messageHtml: string | null = null;
  @Input() confirmText = 'Confirm';
  @Input() cancelText = 'Cancel';
  @Input() confirmVariant: 'danger' | 'primary' = 'danger';
  @Input() loading = false;
  @Input() size: 'sm' | 'md' = 'sm';

  @Output() openChange = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();

  close(): void {
    this.open = false;
    this.openChange.emit(false);
    this.canceled.emit();
  }

  confirm(): void {
    if (this.loading) {
      return;
    }

    this.confirmed.emit();
  }
}
